<ng-container *transloco="let t; scope: 'catalog'">
  <div class="listing-active-filters default-font-sizes default-font-sizes--small" *ngIf="filters?.length > 0">
    <div>
      <div class="listing-active-filter" *ngFor="let filter of filters">
        <span>{{ filter.name }}: </span>
        {{ filter.value }}
        <button (click)="removeFilter(filter)">
          <i class="icon-close"></i>
        </button>
      </div>
    </div>

    <button class="btn-slim listing-content-products-filters-reset" (click)="removeAllFilters()">
      {{ t("catalog.active-filter-list.reset-filters") }}
    </button>
  </div>
</ng-container>
